
import { common as enCommon } from './en/common';
import { common as esCommon } from './es/common';
import { common as ptCommon } from './pt/common';

export const resources = {
  en: {
    translation: enCommon
  },
  es: {
    translation: esCommon
  },
  pt: {
    translation: ptCommon
  }
};
